const REQUEST_HOST = process.env.REACT_APP_REQUEST_HOST;
const FLEX_REQUEST_URL = process.env.REACT_APP_REQUEST_FLEX_URL;
const RISK_SETUP_REQUEST_URL = process.env.REACT_APP_REQUEST_RISK_SETUP_URL;
const POST_VERB = process.env.REACT_APP_REQUEST_VERB_POST;
const RISK_AUTHENTICATION_ENROLL_CHECK_URL =
  process.env.REACT_APP_REQUEST_RISK_AUTHENTICATION_ENROLL_CHECK_URL;
const RISK_AUTHENTICATION_RESULT_URL = process.env.REACT_APP_REQUEST_RISK_AUTHENTICATION_RESULT_URL;
// const HTTPS = 'https';
const ENCRYPTION_TYPE_RSAOAEP = 'RsaOaep';
const MERCHANT_ID = 'testrest';
const AUTH_SUCCESSFUL_STATUS = 'AUTHENTICATION_SUCCESSFUL';
const CONSUMER_AUTH_REQUIRED_REASON_CODE = 'CONSUMER_AUTHENTICATION_REQUIRED';
// const REDIRECT_URL = `${HTTP}://${process.env.REACT_APP_REDIRECT_URL_HOSTNAME}${process.env.REACT_APP_REDIRECT_URL_RESOURCE}`;
const REDIRECT_URL = `https://${window.location.host}/bin/3ds/redirect`;
export {
  REQUEST_HOST,
  FLEX_REQUEST_URL,
  RISK_SETUP_REQUEST_URL,
  RISK_AUTHENTICATION_ENROLL_CHECK_URL,
  RISK_AUTHENTICATION_RESULT_URL,
  POST_VERB,
  ENCRYPTION_TYPE_RSAOAEP,
  MERCHANT_ID,
  AUTH_SUCCESSFUL_STATUS,
  CONSUMER_AUTH_REQUIRED_REASON_CODE,
  REDIRECT_URL
};
